import api from '../api';

const toIsoDate = (date) => {
    if (typeof date === 'string') return date;
    return date.toISOString().split('T')[0];
};

const calendarTaskService = {
    /**
     * Fetch tasks for a date range.
     * @param {Date|string} start
     * @param {Date|string} end
     * @param {AbortSignal} [signal]
     * @returns Promise — resolves to the full API response; response.data.tasks is grouped by YYYY-MM-DD
     */
    getRangeTasks: async (start, end, signal) => {
        const response = await api.get('/calendar/tasks', {
            params: {
                start: toIsoDate(start),
                end: toIsoDate(end),
            },
            signal,
        });
        return response.data?.tasks ?? {};
    },

    /**
     * Create a task.
     * @param {{ title, description, assignee_ids, priority, status, start_at, end_at, all_day, reminder_minutes, recurrence, attachment_ids }} data
     */
    createTask: (data) => {
        return api.post('/calendar/tasks', data);
    },

    /**
     * Update a task.
     * @param {number|string} id
     * @param {object} data
     */
    updateTask: (id, data) => {
        return api.put(`/calendar/tasks/${id}`, data);
    },

    /**
     * Delete a task.
     * @param {number|string} id
     */
    deleteTask: (id) => {
        return api.delete(`/calendar/tasks/${id}`);
    },

    /**
     * Toggle completion of a task.
     * @param {number|string} id
     */
    toggleComplete: (id) => {
        return api.post(`/calendar/tasks/${id}/toggle-complete`);
    },

    /**
     * Cancel a single occurrence of a recurring task.
     * @param {number|string} id
     * @param {string} occurrenceDate - YYYY-MM-DD
     */
    cancelOccurrence: (id, occurrenceDate) => {
        return api.post(`/calendar/tasks/${id}/cancel-occurrence`, {
            occurrence_date: occurrenceDate,
        });
    },

    /**
     * Edit a single occurrence of a recurring task.
     * @param {number|string} id
     * @param {string} occurrenceDate - YYYY-MM-DD
     * @param {object} data
     */
    editOccurrence: (id, occurrenceDate, data) => {
        return api.post(`/calendar/tasks/${id}/edit-occurrence`, {
            occurrence_date: occurrenceDate,
            ...data,
        });
    },

    /**
     * Get a single task by ID.
     * @param {number|string} id
     */
    getTask: (id) => {
        return api.get(`/calendar/tasks/${id}`);
    },
};

export default calendarTaskService;
